import { Badge } from '@chronosphereio/chrono-ui';
import { getDurationFromTimeRangeStart, getFormattedDateTimeRange } from '@chronosphereio/core';
import { useMemo } from 'react';
import { useTimeRange } from '@/plugin-system/runtime/TimeRangeProviderV2';
import { useUserTimeFormat } from '@/plugin-system/runtime/useUserTimeFormat';
import { useTimeZone } from '../context/TimeZoneProvider';

export function RelativeTimeChip() {
  const { timeZone } = useTimeZone();
  const { absoluteTimeRange, timeRange } = useTimeRange();
  const timeFormat = useUserTimeFormat();

  const relativeDuration = getDurationFromTimeRangeStart(timeRange);
  const infoBadgeContent = relativeDuration ? relativeDuration : 'Custom time range';

  // Get resolved absolute time tooltip content
  const formattedTimeRangeWithTimeZone = useMemo(() => {
    return getFormattedDateTimeRange({
      startDate: absoluteTimeRange.start.toString(),
      endDate: absoluteTimeRange.end.toString(),
      timeZone,
      timeFormat,
    });
  }, [absoluteTimeRange.start, absoluteTimeRange.end, timeZone, timeFormat]);
  return infoBadgeContent ? (
    <Badge
      label={infoBadgeContent}
      size="small"
      TooltipContent={formattedTimeRangeWithTimeZone}
      data-testid="relative-time-badge"
    />
  ) : null;
}
